var _path, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPingPong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M47.069 24.025c0 1.228-1 2.228-2.228 2.228-1.23 0-2.23-1-2.23-2.228 0-1.234 1-2.238 2.23-2.238 1.228 0 2.228 1.004 2.228 2.238m-2.228-5.16c-2.846 0-5.16 2.315-5.16 5.16s2.314 5.16 5.16 5.16c2.844 0 5.159-2.315 5.159-5.161-.01-2.844-2.324-5.159-5.159-5.159M40.042 14.144c-.548-.547-1.437-.547-1.986 0l-4.248 4.247-2.979-2.978 4.248-4.248c.548-.548.548-1.438 0-1.985-.548-.549-1.437-.549-1.986 0l-4.247 4.247-2.041-2.04c-.549-.549-1.437-.549-1.986 0-.549.548-.549 1.437 0 1.985l2.041 2.04-4.248 4.248c-.548.549-.548 1.438 0 1.986.274.274.634.412.994.412.359 0 .718-.138.992-.412l4.248-4.248 2.979 2.979-4.248 4.248c-.548.547-.548 1.436 0 1.984.274.275.634.412.993.412.36 0 .719-.137.992-.412l4.248-4.246 1.49 1.489c.274.274.633.412.992.412.36 0 .719-.138.993-.412.549-.549.549-1.437 0-1.986l-1.489-1.49 4.248-4.246c.547-.548.547-1.437 0-1.986",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "p8ewodto1a",
    width: 47,
    height: 47,
    x: 0,
    y: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 2h46.931v46.921H0V2z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#p8ewodto1a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M22.28 32.145l-4.779 1.407-.33-.33-1.801-1.802 1.405-4.776c.641 1.135 1.42 2.197 2.363 3.14.952.95 2.015 1.728 3.143 2.361M46.775 19.1c.672-4.841-.836-9.512-4.138-12.813C36.615.263 26.443.633 19.966 7.113c-3.124 3.123-4.938 7.19-5.108 11.45-.05 1.254.06 2.477.29 3.658l-2.397 8.153c-.083.052-.162.11-.232.182L9.694 33.38c-.548.549-.548 1.438 0 1.986.549.548 1.438.548 1.986 0l1.832-1.833 1.876 1.876L5.072 45.725c-.5.501-1.373.503-1.875-.001-.251-.25-.389-.583-.389-.937 0-.354.138-.687.39-.938l3.248-3.248c.548-.547.548-1.438 0-1.985-.549-.549-1.438-.549-1.986 0L1.21 41.863C.431 42.644 0 43.683 0 44.787c0 1.105.43 2.143 1.211 2.923.781.781 1.82 1.212 2.923 1.212 1.105 0 2.143-.431 2.924-1.212l11.308-11.307c.072-.073.134-.15.187-.234l8.145-2.395c.989.193 1.998.295 3.016.295 4.293 0 8.702-1.718 12.096-5.113.548-.548.548-1.438 0-1.985-.549-.549-1.438-.549-1.986 0-5.385 5.382-13.773 5.754-18.7.827-2.371-2.372-3.6-5.612-3.46-9.123.142-3.552 1.664-6.954 4.288-9.577 5.383-5.383 13.771-5.756 18.698-.827 2.675 2.673 3.894 6.48 3.343 10.442-.106.769.43 1.478 1.198 1.585.769.107 1.477-.43 1.584-1.2",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPingPong);
export default __webpack_public_path__ + "static/media/ping-pong.f5071f46f3671d91985dc2000d5e1986.svg";
export { ForwardRef as ReactComponent };